'use client';

import { ImageComponent } from '../Image';

import { ScPreloaderContainer, ScPreloaderMain } from './styled';

export const Preloader = () => {
  return (
    <ScPreloaderMain>
      <ScPreloaderContainer>
        <ImageComponent
          src="/preloader/preloader.svg?url"
          height={200}
          width={200}
          aria-label="Level Up"
          alt="preloader"
          priority
        />
      </ScPreloaderContainer>
    </ScPreloaderMain>
  );
};
